import type { Ordinance, Ordinances, SPOrdinance } from '@fs/zion-tree-types'
import { ordinancesByType } from '@fs/zion-ordinances-reserve'
import type { PrimaryParents } from '../../../data-service/usePrimaryParents'

export default function getDisplayableOrdinances(
  ordinances: Ordinances | undefined,
  primaryParents?: PrimaryParents
): Ordinance[] {
  const { bcie, sealingsToParents, sealingsToSpouses } = ordinancesByType(ordinances)

  // The Sealing to Parents ordinance get displayed if any of these conditions are true:
  // 1. It is the primary parents.
  //    a. It is the preferred parents with 2 parents.
  //    b. If preferred parents is a single parent, then first set of 2 parents.
  // 2. It is completed, in progress, or shared.
  //    a. It is still a valid completed ordinance, but no longer connected to the focus person.
  // 3. A single parent relationship if none of the above are met; it doesn't matter which, because it is simply an info message that doesn't display the single parent.

  const sealingsToParentsToShow: SPOrdinance[] = sealingsToParents.filter((sealing) => {
    const { parent1Id, parent2Id } = sealing?.relationships ?? { parent1Id: undefined, parent2Id: undefined }
    const isPrimaryParents =
      (parent1Id === primaryParents?.parent1Id && parent2Id === primaryParents?.parent2Id) ||
      (parent1Id === primaryParents?.parent2Id && parent2Id === primaryParents?.parent1Id)
    return isPrimaryParents || /(inprogress)|(completed)|(shared)/i.test(sealing.status)
  })

  if (sealingsToParentsToShow.length === 0 && sealingsToParents[0]) sealingsToParentsToShow.push(sealingsToParents[0])

  return [...bcie, ...sealingsToParentsToShow, ...sealingsToSpouses]
}
